module.exports = __webpack_public_path__ + "img/usmap.4de7ecf2.png";